import { createFileRoute } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";

const FAQS = [
  {
    question: "¿Cómo acceder a los cursos cuando la empresa utiliza los servicios de Mine Class?",
    answer:
      "Para iniciar el proceso de aprendizaje, se debe ingresar al sitio web oficial de la plataforma en https://lms.mine-class.com e iniciar sesión con las credenciales correspondientes. Una vez dentro del sistema, el usuario debe dirigirse a la sección denominada Cursos. Posteriormente, para comenzar la inducción respectiva, se debe hacer clic en la opción Ir al Curso, quedando el sistema habilitado para que el estudiante comience a avanzar por las diferentes unidades académicas.",
  },
  {
    question: "¿Cuál es la reportabilidad disponible en la plataforma?",
    answer:
      "El sistema ofrece un conjunto de indicadores en línea que permiten conocer en todo momento el estado del proceso de capacitación y el progreso detallado de los alumnos. Asimismo, la plataforma cuenta con herramientas de seguimiento y control para monitorear a los estudiantes a través de paneles dinámicos en tiempo real. Adicionalmente, se incluye un diseño de Dashboard que permite la configuración a medida de los indicadores globales requeridos por cada organización.",
  },
  {
    question: "¿Cómo funciona el sistema de reconocimiento facial?",
    answer:
      "La plataforma cuenta con una herramienta tecnológica avanzada que valida de forma rápida y segura la identidad de los estudiantes, garantizando que los usuarios que interactúan con el contenido sean efectivamente las personas registradas en el programa.",
  },
  {
    question: "¿Qué tipo de certificación se otorga al finalizar los programas?",
    answer:
      "Se emite un certificado en formato digital. La institución se encuentra certificada bajo la norma de calidad chilena NCh2827:2015, condición que la habilita formalmente como Organismo Técnico de Capacitación. Debido a este marco regulatorio, la certificación otorgada cuenta con validez internacional y goza de amplio reconocimiento por parte de las principales empresas de la industria.",
  },
];

export const Route = createFileRoute("/preguntas-frecuentes")({
  head: () => ({
    meta: [
      { title: "Preguntas Frecuentes | Mine Class" },
      {
        name: "description",
        content:
          "Respuestas a las dudas más comunes sobre acceso a cursos, reportabilidad, reconocimiento facial y certificación de Mine Class.",
      },
      { property: "og:title", content: "Preguntas Frecuentes | Mine Class" },
      { property: "og:description", content: "Todas las respuestas sobre acceso a cursos, reportabilidad, FaceID y certificación de Mine Class." },
      { property: "og:url", content: "https://mine-class.com/preguntas-frecuentes" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/preguntas-frecuentes" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: Page,
});


function Page() {
  return (
    <SubPage
      eyebrow="Soporte"
      title="Preguntas Frecuentes"
      intro="Resolvemos las dudas más comunes sobre nuestra plataforma, cursos y certificaciones."
    >
      <div className="space-y-4 not-prose">
        {FAQS.map((faq, idx) => (
          <details
            key={idx}
            className="group bg-white border border-[var(--color-outline-variant)] rounded-xl open:shadow-sm transition-all"
          >
            <summary className="flex items-center justify-between gap-4 p-5 cursor-pointer list-none">
              <span className="font-bold text-[var(--color-brand-purple)] text-base">
                {faq.question}
              </span>
              <span className="material-symbols-outlined text-[var(--color-brand-coral)] shrink-0 transition-transform group-open:rotate-180">
                expand_more
              </span>
            </summary>
            <div className="px-5 pb-5 text-[var(--color-on-surface-variant)] leading-relaxed">
              {faq.answer}
            </div>
          </details>
        ))}
      </div>
    </SubPage>
  );
}
